<template>
    <div class="phone_head">
        <div class="head_box">
            <div class="headmain">
                <img @click="goto('/')" class="logo" :src="getpath('/index/logo','.png')" alt="">

                <img @click="changeshow" :class="isshow?'head_arror ac':'head_arror'" :src="getpath('/index/head_arror','.png')" alt="">
                <img @click="changeshow" :class="isshow?'head_close':'head_close ac'" :src="getpath('/index/head_close','.png')" alt="">

            </div>

            <div :class="isshow?'headlist ac':'headlist'">
                <p @click="goto('/')" :class="current==1?'headitem ac':'headitem'"><span class="itempoint"></span> 官网首页</p>
                <p @click="goto('/correct')" :class="current==2?'headitem ac':'headitem'"><span class="itempoint"></span>童伴纠音</p>
                <p @click="goto('/growup')" :class="current==3?'headitem ac':'headitem'"><span class="itempoint"></span>童伴成长</p>
                <p @click="goto('/about')" :class="current==4?'headitem ac':'headitem'"><span class="itempoint"></span>关于我们</p>
            </div>

        </div>


    </div>
  
</template>

<script>
export default {
    data(){
        return{
            isshow:false,
        }
    },
    props:['current'],
    methods:{
        changeshow(){
            this.isshow = !this.isshow;
        },
        goto(path){
            if(path != this.$route.fullPath){
                this.jumpInter(path);
            }
        }
    }

}
</script>

<style lang="scss" scoped>
    .phone_head{
        width: 100vw;
        height: 80px;
        position: fixed;
        left: 0;
        top: 0;
        box-shadow: 4px 2px 4px rgba($color: #254C93, $alpha: .23);
        z-index: 9999;
        background: white;
        .head_box{
            width: 100%;
            height: 80px;
            margin: 0 auto;
            position: relative;
            .headmain{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                background-color: white;
                position: relative;
                z-index: 5;

                .logo{
                    width: 129px;
                    height: 55px;
                    margin-left: 35px;
                }
                .head_arror{
                    width: 30px;
                    height: 30px;
                    position: absolute;
                    right: 30px;
                    transition: all 0.2s linear;
                    transform-origin: center center;
                    opacity: 1;
                    &.ac{
                        transform: rotate(-90deg);
                        opacity: 0;
                    }
                }
                .head_close{
                    width: 30px;
                    height: 30px;
                    position: absolute;
                    right: 30px;
                    transition: all 0.2s linear;
                    transform-origin: center center;
                    opacity: 1;
                    &.ac{
                        transform: rotate(0deg);
                        opacity: 0;
                    }
                }

            }

            .headlist{
                width: 189px;
                height: 260px;
                position: absolute;
                right: 0;
                bottom: 0;
                z-index: 1;
                transition: all .4s ease-in;
                border-bottom-left-radius: 35px;
                padding-top: 20px;
                padding-right: 20px;
                box-sizing: border-box;
                background-color: white;
                &.ac{
                    transform: translateY(90%);
                    box-shadow: -2px 8px 15px rgba($color: #000, $alpha: .3);
                }
                .headitem{
                    font-size: 28px;
                    text-align: right;
                    margin-top: 15px;
                    position: relative;
                    &.ac{
                        color: #2FA0FA;
                        .itempoint{
                            display: block;
                        }
                    }
                    .itempoint{
                        width: 10.31px;
                        height: 10.31px;
                        border-radius: 2px 2px 2px 2px;
                        background: rgba(47,160,250,1);
                        position: absolute;
                        left: 25px;
                        top: 50%;
                        transform: translateY(-50%);
                        display: none;
                    }
                }
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/header.vue